/** Recipe UoM choices that have known Item UoM conversion sets. */
export const RECIPE_UOM_OPTIONS = [
    'oz',
    'floz',
    'tsp',
    'tbsp',
    'cup',
    'quarts',
    'gallons',
    'mL',
    'liter',
    'grams',
    'lbs',
    'units',
    'none',
]

/** Full UoM list when any unit may be chosen. */
export const ALL_UOM_OPTIONS = [
    'oz',
    'floz',
    'tsp',
    'tbsp',
    'cup',
    'pint',
    'pints',
    'quarts',
    'gallons',
    'mL',
    'liter',
    'grams',
    'lbs',
    'units',
    'each',
    'none',
]

/**
 * Allowed Item (PAR) UoMs for a given Recipe UoM.
 * Returns { [recipeUoM]: string[] } or null.
 */
export function UoMMenuOptions(selectedUoM) {
    try {
        const itemUoM = [
            { oz: ['grams', 'lbs', 'gallons', 'oz'] },
            { floz: ['tbsp', 'cup', 'gallons', 'pints', 'quarts', 'liter', 'floz'] },
            { tsp: ['tbsp', 'tsp'] },
            { tbsp: ['tsp', 'floz', 'tbsp'] },
            { lbs: ['grams', 'oz', 'lbs'] },
            { grams: ['oz', 'lbs', 'grams'] },
            { cup: ['lbs', 'gallons', 'floz', 'cup'] },
            { units: ['units'] },
            { quarts: ['floz', 'gallons', 'cup', 'quarts'] },
            { gallons: ['oz', 'floz', 'quarts', 'cup', 'gallons'] },
            { mL: ['liter', 'mL'] },
            { liter: ['mL', 'floz', 'liter'] },
            { none: ['none'] },
        ]
        return itemUoM.find((o) => Object.prototype.hasOwnProperty.call(o, selectedUoM)) || null
    } catch (err) {
        console.log(err)
        return null
    }
}

/** Item UoM options for a recipe unit, always including the current value if set. */
export function itemUomOptionsForRecipe(recipeUoM, currentItemUoM) {
    const mapped = UoMMenuOptions(recipeUoM)
    const allowed = mapped?.[recipeUoM] ? [...mapped[recipeUoM]] : []
    const current = String(currentItemUoM || '').trim()
    if (current && !allowed.includes(current)) allowed.unshift(current)
    return allowed
}
